export default __webpack_public_path__ + "assets/audio/ssml/emphasis.ff7135c3a6ff4c3c8fc8f60dc7d09493.mp3";